import { PropsWithChildren } from 'react';
import { message, toDisplayCurrency } from '../../../utils';
import { GraySpan } from '../../_atoms';
import { Heading } from '../../heading';
import { Paragraph } from '../../paragraph';
import { Tooltip } from '../../tooltip';
import { FlexRowDiv, StyledInfoTile } from './styled';

export type BalanceInfoTileProps = {
  amount: number;
  infoMessage: string | JSX.Element;
  infoTitle?: string;
} & PropsWithChildren<{ title: string }>;

export function BalanceInfoTile({
  amount,
  title,
  infoMessage,
  infoTitle
}: BalanceInfoTileProps): JSX.Element {
  return (
    <StyledInfoTile>
      <div>
        <Heading variant="h5">
          <GraySpan>{title}</GraySpan>
        </Heading>
        <FlexRowDiv>
          <Paragraph variant="extra-large" bold>
            {toDisplayCurrency(amount, 'EUR')}
          </Paragraph>
        </FlexRowDiv>
      </div>
      <div>
        <Paragraph>
          <Tooltip title={message(infoTitle, 'More info')} showRule="click">
            {infoMessage}
          </Tooltip>
        </Paragraph>
      </div>
    </StyledInfoTile>
  );
}
